<template>
  <div v-click-outside="closeModal" class="header-wrapper">
    <div v-show="!dealerName" class="select-store">
      <a :href="`/locator/?changeDealer=true&returnurl=${returnUrl}`"
        class="">
        {{ "dealers.details.selectStore" | t }}
      </a>
        <span class="icon icon-stihl-angle-right"></span>
    </div>
    <section class="header-container">
      <section class="col1">
        <YourDealer v-show="dealerName" :dealerName="dealerName" class="your-dealer" />
        <div class="right-group">
          <CurrentStoreHours v-show="showStoreHours" :storeHours="dealerStoreHours" class="current-store-hours" />
          <DealerRating v-if="dealerName"
          :reviewRating="dealerRating"
          :reviewCount="reviewCount"
          class="dealer-rating"/>
        </div>
      </section>
      <section v-if="dealerName" class="col2">
        <ToggleIcon v-bind:class="{modal_open: isModalOpen}" />
      </section>
    </section>

    <DealerModal :isOpen="isModalOpen" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CurrentStoreHours from "@/components/CurrentStoreHours.vue";
import DealerRating from "@/components/DealerRating.vue";
import YourDealer from "@/components/YourDealer.vue";
import DealerModal from "@/components/DealerModal.vue";
import clickOutside from "@/directives/clickOutside";
import ToggleIcon from "@/components/ToggleIcon";

export default {
  name: "HeaderWrapper",
  data() {
    return {
      returnUrl: window.location.href,
    };
  },
  computed: {
    ...mapGetters("DealerHeader", [
      "dealer",
      "showStoreHours",
      "dealerStoreHours",
      "dealerRating",
      "reviewCount",
      "dealerName",
      "isModalOpen"
    ]),
    cartUrl() {
      return this.dealer?.shopSiteLink != null ? this.dealer.shopSiteLink+'checkout' : "";
    }
  },
  methods: {
    closeModal() {
      if (this.isModalOpen) {
        this.$dataLayer.push({ event: "pcedh.header-closed" })
        this.$store.dispatch("DealerHeader/closeModal")
      }
    }
  },
  directives: {
    clickOutside
  },
  components: {
    CurrentStoreHours,
    DealerModal,
    DealerRating,
    YourDealer,
    ToggleIcon
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header-wrapper {
  position: relative;

  .icon.icon-stihl-angle-right::before {
    line-height: 39px;
  }

  .select-store {
    line-height: 36px;
    display: flex;
    justify-content: flex-end;

    .icon {
      margin-left: 10px;
      line-height: 36px;
    }

    a {
      color: $black;
      cursor: pointer;
      font-family: $font-title;
      text-decoration: none;
    }
  }

  .header-container {
    padding: $gutter-sm;
    max-height: 16px;
    .right-group {
      @include flexbox;
      @media screen AND (min-width: $breakpoint-md) {
        justify-content: flex-end;
      }
    }
    @media screen AND (max-width: $breakpoint-md) {
      border-bottom: 1px solid #dfdfdf;
    }
  }
  

  .icon {
    font-family: $font-icons;
  }
  section {
    display: flex;
    > * {
      flex: 1 100%;
    }
  }

  .toggle-icon {
    margin-right: 6px;
  }

  .toggle-icon,
  .dealer-rating,
  .current-store-hours,
  .cart-link {
    @include flexbox;
  }

  .current-store-hours {
    margin-left: auto;
  }
  .dealer-rating,
  .current-store-hours {
    flex: 0 0 auto;
    margin-left: 20px;
  }

  .col1 {
    flex: 1 100%;
  }
  .col2 {
    display: none;
  }

  @media screen AND (max-width: $breakpoint-md) {
    .dealer-rating,
    .current-store-hours {
      margin-right: 6px;
    }
    section {
      flex-flow: row wrap;
    }
   .header-container {
      max-height: 36px;
    }
    .your-dealer {
      order: 0;
    }
    .toggle {
      order: 5;
    }
    .current-store-hours {
      order: 3;
    }
    .dealer-rating {
      order: 4;
    }
    .cart-link {
      display: none;
    }

    .current-store-hours,
    .dealer-rating {
      margin-top: 3px;
      margin-left: unset;
    }

    .col1 {
      flex: 1;
      width: 90%;
      > .your-dealer .toggle-icon {
        display: none;
      }
    }

    .col2 {
      display: flex;
      flex: 0 0 auto;
      align-items: center;
    }
  }
}
</style>
